import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Grid from '@material-ui/core/Grid';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    },
    toggleButton: {
        width: '100%',
    },
    toggleButtonGroup: {
        width: '100%',
    }
});


interface IFSQuestionProps {
    grade: string | undefined;
    setFSQuestion: (event) => void;
    fsQuestion: boolean | undefined;
    disabled: boolean;
    subject: string;
}

interface IFSQuestionState {
    fsQuestionRequired: boolean;
    loaded: boolean;
}

class FSQuestion extends Component<IFSQuestionProps & WithStyles<typeof styles>, IFSQuestionState> {
    constructor(props) {
        super(props);
        this.state = {
            fsQuestionRequired: false,
            loaded: false
        }
    }

    componentDidMount() {
        if (this.props.grade !== undefined) {
            fetch('api/DropDown/gradeRequiresFSQuestion?grade=' + this.props.grade)
                .then(response => response.json()).then((data) => {
                    this.setState({
                        fsQuestionRequired: data,
                        loaded: true,
                    });
                });
        } else {
            this.setState({ loaded: true })
        }
    }

    componentWillReceiveProps(prevProps) {
        if (this.props.grade !== prevProps.grade) {
            if (this.props.grade !== undefined) {
                fetch('api/DropDown/gradeRequiresFSQuestion?grade=' + this.props.grade)
                    .then(response => response.json()).then((data) => {
                        this.setState({
                            fsQuestionRequired: data,
                            loaded: true,
                        });
                    });
            } else {
                this.setState({ loaded: true })
            }
        }
    }

    public render() {
        return (
            this.state.fsQuestionRequired ? 
                <Grid item xs={12}>
                    <ToggleButtonGroup
                        value={this.props.fsQuestion}
                        exclusive
                        onChange={this.handleChange}
                        aria-label={"Do you have FS L2 in " + this.props.subject}
                        className={this.props.classes.toggleButtonGroup}
                    >
                        <ToggleButton value={false} aria-label={"I do not have a FS L2 " + this.props.subject + ' qualification'} className={this.props.classes.toggleButton}>
                            {"I do not have a FS L2 " + this.props.subject + ' qualification'}
                        </ToggleButton>
                        <ToggleButton value={true} aria-label={"I have a FS L2 " + this.props.subject + ' qualification'} className={this.props.classes.toggleButton}>
                            {"I have a FS L2 " + this.props.subject + ' qualification'}
                        </ToggleButton>

                    </ToggleButtonGroup>
                </Grid>
                :
                <React.Fragment />
        );
    }

    private handleChange = (event, newAlignment) => {
        if (newAlignment !== null) {
            this.props.setFSQuestion(newAlignment);
        }
    }
}

export default withStyles(styles)(FSQuestion);